import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CrlInviteDialogComponent, CrlInviteDialogData } from './crl-invite-dialog.component';

/** Pairs with the full-screen rule in `styles/vendors/material/_mat-dialog.scss`. */
export const CRL_INVITE_DIALOG_PANEL_CLASS = 'cxp-crl-invite-dialog-panel';

/**
 * Companion service for the CRL "Invite" dialog (cxp-dialog: one service opens the
 * dialog, the component owns the mutation). There is deliberately NO permission
 * guard — invite is shown to everyone and the backend authorizes the request
 * (PP-3642 decision). The dialog dispatches `InviteContactToItems` itself.
 */
@Injectable({ providedIn: 'root' })
export class CrlInviteDialogService {
  private readonly dialog = inject(MatDialog);

  /** Opens the Invite dialog on `itemId`, which it pre-selects in its item tree. */
  openInviteDialog(itemId: number): void {
    this.dialog.open(CrlInviteDialogComponent, {
      data: { itemId } as CrlInviteDialogData,
      // Drives the full-screen treatment below the tablet tier; the rule lives
      // in styles/vendors/material/_mat-dialog.scss because the overlay pane it
      // targets sits outside the component.
      panelClass: CRL_INVITE_DIALOG_PANEL_CLASS,
    });
  }
}
